var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconMarkerFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C7.814 0 4 3.74 4 8.333c0 7.351 7.772 16.118 8.102 16.488A.532.532 0 0012.5 25a.552.552 0 00.398-.179C13.228 24.445 21 15.527 21 8.333 21 3.74 17.186 0 12.5 0zm0 5.73c1.76 0 3.188 1.399 3.188 3.124S14.26 11.98 12.5 11.98c-1.76 0-3.188-1.4-3.188-3.125S10.74 5.73 12.5 5.73z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

export default SvgCommonIconMarkerFilled;